import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../../services/auth.service';
import { OverlayService } from '../../../services/overlay.service';
import { BeeFreeService } from '../../../services/beefree.service';
import { MaintenanceService } from '../../../services/maintenance.service';
import { EmbeddedFrameService } from '../../../services/embedded-frame.service';
import { environment } from '../../../../environments/environment';

@Component({
	selector: 'app-login',
	templateUrl: './login.component.html',
	styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
	formFailed = false;
	isBeeFree: boolean;
	apiLoginErrorMsg = 'Please provide a valid email and password.';
	coverHeight = '100%';
	embeddedCoverHeight = 'calc(100% - 53px)';
	isEmbedded = false;
	apiLoginErrMsg = 'Please provide a valid email and password.';
	webComponentDomain = environment.webComponentUrl;

	constructor(
		private auth: AuthService,
		private overlay: OverlayService,
		private beeFree: BeeFreeService,
		private maintenance: MaintenanceService,
		private embeddedFrameService: EmbeddedFrameService
	) {}

	ngOnInit() {
		this.isBeeFree = this.beeFree.isBeeFreeAddon();
		if (this.maintenance.inMaintenance()) {
			this.maintenance.redirectToMaintenancePage();
		}
		this.isEmbedded = this.embeddedFrameService.isEmbeddedFrame();
		this.coverHeight = this.isEmbedded ? this.embeddedCoverHeight : this.coverHeight;
	}

	submit(values): boolean | void {
		this.auth.newAPILoginWithEmailAndPassword(values.email, values.password).subscribe(
			(resp) => {
				if (!resp.status) {
					this.formFailed = true;
					setTimeout(() => {
						this.formFailed = false;
					}, 2000);
					this.overlay.updateOverlay(true, this.apiLoginErrorMsg, 'alert');
				}
			},
			(err) => {
				this.overlay.updateOverlay(true, this.apiLoginErrorMsg, 'alert');
				this.maintenance.serverMaintenance(err);
			}
		);
	}

	cancelBeeFree() {
		this.beeFree.cancelAddon();
	}
}
